import React, { useState, useEffect, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, ChevronDown, ChevronUp, Send, User, Clock, CheckCircle, Edit, Delete, UserCogIcon, Pointer, ArrowBigLeftDash } from 'lucide-react';
import Link from '../components/Link';
import { checkLoginStatus, getAllUsers, getUserData } from '../api/authService';
import { Toast } from '../components/Toast';
import TimeAgo from '../components/TimeAgo';

// interface Question {
//   id: string;
//   content: string;
//   author: string;
//   timestamp: string;
//   answer?: {
//     content: string;
//     author: string;
//     timestamp: string;
//     isOfficial: boolean;
//   };
//   replies: Reply[];
// }

// interface Reply {
//   id: string;
//   content: string;
//   author: string;
//   timestamp: string;
//   isReplyToAnswer?: boolean;
// }

// interface StudyData {
//   id: string;
//   title: string;
//   thumbnail: string;
// }

type Answer = {
  content: string;
  author: string;
  timestamp: string;
};

type Reply = {
  content: string;
  author: string;
  timestamp: string;
};

type Question = {
  id: string;
  content: string;
  author: string;
  author_id: string,
  type: string;
  parent_id: string,
  history: any;
  timestamp: string;
  is_reply_to_answer: any,
  speaker: string;
  emailNotifications: string,
  // type: Reply[];
};

type UserData = {
  username: string;
  id: string;
  youtube_id: string;
  email: string
};

type StudyData = {
  id: string;
  title: string;
  thumbnail: string;
  youtube_id: string;
  speaker: string;
};

export default function Ask() {
  // const [searchParams] = useSearchParams();
  const [studyId, setStudyID] = useState(null);
  const [studyData, setStudyData] = useState<StudyData | null>(null);
  const [questions, setQuestions] = useState<Question[]>([]);
  const [newQuestion, setNewQuestion] = useState('');
  const [expandedQuestions, setExpandedQuestions] = useState<Set<string>>(new Set());
  const [expandedAnswers, setExpandedAnswers] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [replyText, setReplyText] = useState<{ [key: string]: string }>({});
  const [replying, setReplying] = useState<string | null>(null);
  const [user, setUser] = useState<UserData | null>(null); // holds full user data
  const [showAdmin, setShowAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [replyVisible, setReplyVisible] = useState<{ [key: string]: boolean }>({});
  const [isAnswerToggle, setIsAnswerToggle] = useState<{ [key: string]: boolean }>({});
  const [editingId, setEditingId] = useState<string | null>(null);
  const [editingText, setEditingText] = useState<string>('');
  const [referredTo, setReferredTo] = useState<string>('');
  const [whosResponding, setWhosResponding] = useState<string>('');
  const [emailNotifications, setEmailNotifications] = useState<string>('');
  const [allUsers, setAllUsers] = useState([]);
  const [adminUsers, setAdminUsers] = useState([]);



  const Replies = useMemo(() => {

    const filtered = questions.filter((item) => item.type === "reply");

    return filtered
  }, [questions])




  useEffect(() => {
    handleStartUp();
    fetchUserData();
  }, []);

  const handleStartUp = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get("id");

    if (!id) {
      alert("no Id");
      setLoading(false)
      return;
    }

    fetchLibraryItem(id)

  }

  const fetchLibraryItem = async (id: any) => {
    const endpoint = `https://tsoministries.com/wp-json/wp/v2/library/${id}`;
    try {
      const response = await fetch(`${endpoint}`);

      if (!response.ok) {
        console.error(`Error fetching data`);
      }

      const data = await response.json();
      setStudyData(data);
      setLoading(false);
      fetchQuestions(data.youtube_id);
    } catch (error) {
      console.error('Failed to fetch library items:', error);
      setLoading(false);
    }
  };

  const fetchQuestions = async (youtube_id: string) => {
    try {
      const res = await fetch(`https://tsoministries.com/wp-json/custom-form/v1/questions/active?youtube_id=${youtube_id}`);
      if (!res.ok) throw new Error('Failed to fetch questions');
      const data = await res.json();

      const filtered = data.filter((q: any) => q.deleted !== '1' && q.deleted !== true);

      setQuestions(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchUserData = async () => {
    const loggedIn = await checkLoginStatus();
    if (!loggedIn) {
      return;
    }
    try {
      const userData = await getUserData();
      if (!userData) {
        Toast.error('Error fetching user:');
        return;
      }
      setUser(userData);
      if (userData?.roles?.includes('editor') || userData?.roles?.includes('administrator')) {
        setShowAdmin(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      Toast.error('Error fetching user:' + error);
    } finally {
      setIsLoading(false);
    }
  };




  const fetchUsers = async () => {
    const users = await getAllUsers();
    if (users) {
      setAllUsers(users);

      const admins = users.filter((user: any) =>
        user.roles?.some((role: string) => ['administrator', 'editor'].includes(role))
      );
      setAdminUsers(admins);
    }
  };

  const prepareEmailNotifications = async (old_emailNotifications: string | string[]) => {
    // Get fresh users directly
    const users = await getAllUsers();
    if (!users) return;

    // Separate admins
    const admins = users.filter((user: any) =>
      user.roles?.some((role: string) => ['administrator', 'editor'].includes(role))
    );

    const arrayOfAdmins = admins.map((value: any) => value.email);

    // Add current user email (if available)
    if (user?.email) {
      arrayOfAdmins.push(user.email);
    }

    // Normalize `old_emailNotifications` (string[] or comma string)
    const oldList = Array.isArray(old_emailNotifications)
      ? old_emailNotifications
      : old_emailNotifications.split(',').map((s) => s.trim()).filter(Boolean);

    // Merge + dedupe
    const merged = Array.from(new Set([...arrayOfAdmins, ...oldList]));

    const emailNotifications = merged.join(',')

    // Save as comma-separated string
    setEmailNotifications(emailNotifications);
    return emailNotifications;
  };


  const toggleQuestionReplies = (questionId: string) => {
    const newExpanded = new Set(expandedQuestions);
    if (newExpanded.has(questionId)) {
      newExpanded.delete(questionId);
    } else {
      newExpanded.add(questionId);
    }
    setExpandedQuestions(newExpanded);
  };

  const toggleAnswerReplies = (questionId: string) => {
    const newExpanded = new Set(expandedAnswers);
    if (newExpanded.has(questionId)) {
      newExpanded.delete(questionId);
    } else {
      newExpanded.add(questionId);
    }
    setExpandedAnswers(newExpanded);
  };

  const handleReplySubmit = async (questionId: string, emailNotifications: string) => {
    const content = replyText[questionId]?.trim();
    if (!content) return;

    setReplying(questionId);
    const emailNotifications_new = await prepareEmailNotifications(emailNotifications);

    try {
      const res = await fetch(`https://tsoministries.com/wp-json/custom-form/v1/question`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          content,
          author: user?.username || 'Guest User',
          author_id: user?.id || 9999999999,
          youtube_id: studyData?.youtube_id || '',
          speaker: whosResponding || '',
          type: 'reply',
          parent_id: parseInt(questionId, 10),
          is_reply_to_answer: isAnswerToggle[questionId] || false,
          deleted: false,
          timestamp: new Date().toISOString(),
          emailNotifications: emailNotifications_new
        }),
      });

      if (!res.ok) throw new Error('Failed to submit reply');

      setReplyText((prev) => ({ ...prev, [questionId]: '' }));
      setReplyVisible({});
      setIsAnswerToggle({});
      setReferredTo('');
      setWhosResponding('');
      Toast.success('Reply submitted successfully');
      fetchQuestions(studyData?.youtube_id || '');
    } catch (err) {
      setReplyVisible({});
      setIsAnswerToggle({});
      setReferredTo('');
      setWhosResponding('');
      Toast.error('Failed to submit reply');
      console.error(err);
    } finally {
      setReplying(null);
    }
  };

  const handleSubmitQuestion = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newQuestion.trim() || !studyData?.youtube_id) return;

    setSubmitting(true);
    const emailNotifications = await prepareEmailNotifications([]);

    try {
      const res = await fetch(`https://tsoministries.com/wp-json/custom-form/v1/question`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          content: newQuestion,
          author: user?.username || 'Guest User',
          author_id: user?.id || 9999999999,
          youtube_id: studyData.youtube_id,
          speaker: referredTo,
          type: 'question',
          parent_id: 0,
          is_reply_to_answer: false,
          timestamp: new Date().toISOString(),
          deleted: false,
          emailNotifications
        }),
      });

      if (!res.ok) throw new Error('Failed to submit question');

      setNewQuestion('');
      setReplyVisible({});
      setIsAnswerToggle({});
      setReferredTo('');
      setWhosResponding('');
      Toast.success('Question submitted successfully');
      fetchQuestions(studyData.youtube_id);
    } catch (err) {
      setReplyVisible({});
      setIsAnswerToggle({});
      Toast.error('Failed to submit question');
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleEdit = async (id: string, newContent: string) => {
    try {
      const res = await fetch(`https://tsoministries.com/wp-json/custom-form/v1/question/edit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, content: newContent, timestamp: new Date().toISOString(), }),
      });

      const data = await res.json();

      if (data?.message === 'Post updated') {
        Toast.success('Edit successfully');
        fetchQuestions(studyData?.youtube_id || '');
      } else {
        Toast.error('Failed to update this content');
        console.error(data);
      }
    } catch (err) {
      console.error('Edit error:', err);
      Toast.error('Something went wrong while updating.');
    }
  };

  const handleDelete_ = async (id: any) => {
    // const confirm = window.confirm("Are you sure you want to delete this?");
    // if (!confirm) return;

    try {
      const res = await fetch(`https://tsoministries.com/wp-json/custom-form/v1/question/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id }),
      });

      const data = await res.json();
      if (data.message) {
        Toast.success('Deleted successfully');
        fetchQuestions(studyData?.youtube_id || '');
      }
    } catch (err) {
      console.error(err);
      Toast.error('Failed to delete.');
    }
  };

  const handleDelete = async (id: any) => {
    Toast.callBack.warning("Are you sure you want to delete this?", {
      onConfirm: async () => {
        handleDelete_(id)
      },
      onCancel: () => {
        // Toast.info("Delete cancelled.");
      }
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-amber-500"></div>
      </div>
    );
  }

  const toggleReferredTo = (name: string) => {
    let current = referredTo.split(',').map((s) => s.trim()).filter(Boolean);

    if (current.includes(name)) {
      current = current.filter((n) => n !== name); // remove if unchecked
    } else {
      current.push(name); // add if checked
    }

    setReferredTo(current.join(', '));
  };

  const toggleWhosResponding = (name: string) => {
    let current = whosResponding.split(',').map((s) => s.trim()).filter(Boolean);

    if (current.includes(name)) {
      current = current.filter((n) => n !== name); // remove if unchecked
    } else {
      current.push(name); // add if checked
    }

    setWhosResponding(current.join(', '));
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24"
    >
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        {/* Header with Video Thumbnail */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <div className="flex items-center gap-6 mb-6">
            <div className="w-24 h-16 rounded-lg overflow-hidden flex-shrink-0">
              <img
                src={studyData?.thumbnail}
                alt={studyData?.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h1 className="text-3xl font-bold mb-2">Questions & Answers</h1>
              <p className="text-gray-400">{studyData?.title}</p>
            </div>
          </div>

          <Link
            to={`/study?id=${studyData?.id}`}
            className="text-amber-400 hover:text-amber-300 transition-colors"
          >
            ← Back to Study
          </Link>
        </motion.div>


        {/* <p>{JSON.stringify(studyData)}</p> */}

        {/* Questions List */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mb-8 space-y-6"
        >

          {questions.map((question) => {
            if (question.type !== "question") return null;

            const relatedReplies = Replies.filter(reply => reply.parent_id === String(question.id));
            // const officialAnswer = relatedReplies.find(reply => reply.is_reply_to_answer === true);
            // const normalReplies = relatedReplies.filter(reply => reply.is_reply_to_answer !== true);

            const officialAnswer = relatedReplies.filter(reply => reply.is_reply_to_answer === "1" || reply.is_reply_to_answer === true);
            const normalReplies = relatedReplies.filter(reply => reply.is_reply_to_answer !== "1" && reply.is_reply_to_answer !== true);

            return (
              <div
                key={question.id}
                className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden"
              >
                <div className="p-6">
                  {/* Question */}
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-gradient-to-br from-amber-600 to-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <User className="w-5 h-5" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2 justify-between">
                        <div className="flex items-center gap-2">
                          <span className="font-medium">{question.author}</span>
                          <TimeAgo className="text-gray-400 text-sm" timestamp={question.timestamp} />
                          {/* <p>{`${user?.id}, ${question.author_id.toString()}`}</p> */}
                        </div>
                        {user?.id.toString() === question.author_id.toString() && (
                          <div className="flex gap-2 text-xs">
                            <button
                              onClick={() => {
                                setEditingId(question.id);
                                setEditingText(question.content);
                              }}
                              className="text-blue-400 hover:underline"
                            >
                              <Edit size={17} />
                            </button>
                            <button
                              onClick={() => handleDelete(question.id)}
                              className="text-red-400 hover:underline ml-1"
                            >
                              <Delete size={17} />
                            </button>
                          </div>
                        )}
                      </div>
                      {question.speaker && (
                        <div className="mb-2">
                          <Pointer className="inline w-3 h-3 text-amber-400 mr-1 rotate-90" />
                          <span className="text-xs bg-amber-600 px-2 py-1 rounded-full">To: {question.speaker}</span>
                        </div>
                      )}
                      {editingId === question.id ? (
                        <div className="space-y-2">
                          <textarea
                            className="w-full bg-white/5 border border-white/10 rounded p-2 text-white text-sm"
                            value={editingText}
                            onChange={(e) => setEditingText(e.target.value)}
                          />
                          <div className="flex gap-2">
                            <button
                              onClick={() => {
                                handleEdit(question.id, editingText);
                                setEditingId(null);
                              }}
                              className="text-green-400 hover:underline text-sm"
                            >
                              Save
                            </button>
                            <button
                              onClick={() => setEditingId(null)}
                              className="text-gray-400 hover:underline text-sm"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      ) : (
                        <p className="text-gray-200">{question.content} {question.history.length >= 1 && <span className='text-gray-300 text-[9px] opacity-50'>edited</span>}</p>
                      )}
                    </div>
                  </div>

                  {/* Official Answer */}
                  {officialAnswer && (
                    officialAnswer.map((officialAnswer) =>
                      <div className="mt-6 ml-14 bg-white/5 rounded-xl p-4 border-l-4 border-green-500">
                        <div className="flex items-start gap-4">
                          <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                            <CheckCircle className="w-4 h-4" />
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center gap-2 mb-2">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2">
                                  <span className="font-medium text-green-400">{officialAnswer.author}</span>
                                  <span className="text-xs bg-green-600 px-2 py-1 rounded-full">Official Answer</span>
                                  <span className="text-gray-400 text-sm">•</span>
                                  <TimeAgo className="text-gray-400 text-sm" timestamp={officialAnswer.timestamp} />
                                </div>
                                {user?.id.toString() === officialAnswer.author_id.toString() && (
                                  <div className="flex gap-2 text-xs ml-4">
                                    <button
                                      onClick={() => {
                                        setEditingId(officialAnswer.id);
                                        setEditingText(officialAnswer.content);
                                      }}
                                      className="text-blue-400 hover:underline"
                                    >
                                      <Edit size={17} />
                                    </button>
                                    <button
                                      onClick={() => handleDelete(officialAnswer.id)}
                                      className="text-red-400 hover:underline ml-1"
                                    >
                                      <Delete size={17} />
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                            {officialAnswer.speaker && (
                              <div className="mb-2">
                                <ArrowBigLeftDash className="inline w-3 h-3 text-amber-400 mr-1" />
                                <span className="text-xs bg-amber-600 px-2 py-1 rounded-full">From: {officialAnswer.speaker}</span>
                              </div>
                            )}
                            {editingId === officialAnswer.id ? (
                              <div className="space-y-2">
                                <textarea
                                  className="w-full bg-white/5 border border-white/10 rounded p-2 text-white text-sm"
                                  value={editingText}
                                  onChange={(e) => setEditingText(e.target.value)}
                                />
                                <div className="flex gap-2">
                                  <button
                                    onClick={() => {
                                      handleEdit(officialAnswer.id, editingText);
                                      setEditingId(null);
                                    }}
                                    className="text-green-400 hover:underline text-sm"
                                  >
                                    Save
                                  </button>
                                  <button
                                    onClick={() => setEditingId(null)}
                                    className="text-gray-400 hover:underline text-sm"
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <p className="text-gray-200">{officialAnswer.content} {officialAnswer.history.length >= 1 && <span className='text-gray-300 text-[9px] opacity-50'>edited</span>}</p>
                            )}
                            {/* <p className="text-gray-200">{officialAnswer.content}</p> */}
                          </div>
                        </div>
                      </div>
                    )
                  )}

                  {/* Replies Toggle */}
                  {normalReplies.length > 0 && (
                    <div className="mt-4 ml-14">
                      <button
                        onClick={() => toggleQuestionReplies(question.id)}
                        className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
                      >
                        {expandedQuestions.has(question.id) ? (
                          <ChevronUp className="w-4 h-4" />
                        ) : (
                          <ChevronDown className="w-4 h-4" />
                        )}
                        <span>
                          {normalReplies.length} {normalReplies.length === 1 ? 'reply' : 'replies'}
                        </span>
                      </button>

                      <AnimatePresence>
                        {expandedQuestions.has(question.id) && (
                          <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: 'auto', opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            className="mt-4 space-y-3"
                          >
                            {normalReplies.map((reply) => (
                              <div
                                key={reply.id}
                                className="flex items-start gap-3 pl-4 border-l-2 border-gray-600"
                              >
                                <div className="w-6 h-6 bg-gray-600 rounded-full flex items-center justify-center flex-shrink-0">
                                  <User className="w-3 h-3" />
                                </div>
                                <div className="flex-1">
                                  <div className="flex items-center justify-between mb-1">
                                    <div className="flex items-center gap-2">
                                      <span className="text-sm font-medium">{reply.author}</span>
                                      <span className="text-gray-400 text-xs">•</span>
                                      <TimeAgo className="text-gray-400 text-xs" timestamp={reply.timestamp} />
                                    </div>
                                    {user?.id.toString() === reply.author_id.toString() && (
                                      <div className="flex gap-2 text-xs">
                                        <button
                                          onClick={() => {
                                            setEditingId(reply.id);
                                            setEditingText(reply.content);
                                          }}
                                          className="text-blue-400 hover:underline"
                                        >
                                          <Edit size={17} />
                                        </button>
                                        <button
                                          onClick={() => handleDelete(reply.id)}
                                          className="text-red-400 hover:underline ml-1"
                                        >
                                          <Delete size={17} />
                                        </button>
                                      </div>
                                    )}
                                  </div>

                                  {reply.speaker && (
                                    <div className="mb-2">
                                      <ArrowBigLeftDash className="inline w-3 h-3 text-amber-400 mr-1" />
                                      <span className="text-xs bg-amber-600 px-2 py-1 rounded-full">From: {reply.speaker}</span>
                                    </div>
                                  )}
                                  {editingId === reply.id ? (
                                    <div className="space-y-2">
                                      <textarea
                                        className="w-full bg-white/5 border border-white/10 rounded p-2 text-white text-sm"
                                        value={editingText}
                                        onChange={(e) => setEditingText(e.target.value)}
                                      />
                                      <div className="flex gap-2">
                                        <button
                                          onClick={() => {
                                            handleEdit(reply.id, editingText);
                                            setEditingId(null);
                                          }}
                                          className="text-green-400 hover:underline text-sm"
                                        >
                                          Save
                                        </button>
                                        <button
                                          onClick={() => setEditingId(null)}
                                          className="text-gray-400 hover:underline text-sm"
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <p className="text-gray-200">{reply.content} {reply.history.length >= 1 && <span className='text-gray-300 text-[9px] opacity-50'>edited</span>}</p>
                                  )}
                                  {/* <p className="text-sm text-gray-300">{reply.content}</p> */}
                                </div>
                              </div>
                            ))}
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  )}

                  {/* Reply Input */}
                  <div className="mt-4 ml-14">
                    {user ? (
                      <>
                        <button
                          onClick={() =>
                            setReplyVisible((prev) => ({ ...prev, [question.id]: !prev[question.id] }))
                          }
                          className="text-sm text-amber-400 hover:text-amber-300 transition mb-2"
                        >
                          {replyVisible[question.id] ? 'Cancel' : 'Reply'}
                        </button>

                        {replyVisible[question.id] && (
                          <div className="space-y-2">
                            <textarea
                              value={replyText[question.id] || ''}
                              onChange={(e) =>
                                setReplyText({ ...replyText, [question.id]: e.target.value })
                              }
                              placeholder="Write a reply..."
                              className="w-full h-20 bg-white/5 rounded-lg border border-white/10 p-2 text-white text-sm placeholder-gray-400"
                            />

                            {showAdmin && (
                              <div>
                                <label className="flex items-center gap-2 text-sm text-gray-300">
                                  <input
                                    type="checkbox"
                                    checked={isAnswerToggle[question.id] || false}
                                    onChange={(e) =>
                                      setIsAnswerToggle({
                                        ...isAnswerToggle,
                                        [question.id]: e.target.checked,
                                      })
                                    }
                                    className="form-checkbox accent-green-500"
                                  />
                                  Mark as Official Answer
                                </label>

                                {/* Dropdown for WhosResponding */}
                                {studyData?.speaker && (
                                  <div className="relative">
                                    <details className="bg-white/5 border border-white/10 rounded p-2">
                                      <summary className="cursor-pointer text-sm text-gray-300">
                                        Who's Answering: {whosResponding || 'Select speaker(s)'}
                                      </summary>
                                      <div className="mt-2 space-y-2">
                                        {studyData.speaker.split(',').map((name) => {
                                          const trimmed = name.trim();
                                          return (
                                            <label key={trimmed} className="flex items-center gap-2 text-sm text-gray-200">
                                              <input
                                                type="checkbox"
                                                checked={whosResponding.split(',').map(s => s.trim()).includes(trimmed)}
                                                onChange={() => toggleWhosResponding(trimmed)}
                                              />
                                              {trimmed}
                                            </label>
                                          );
                                        })}
                                      </div>
                                    </details>
                                  </div>
                                )}
                              </div>
                            )}

                            <button
                              disabled={!replyText[question.id]?.trim()}
                              onClick={() => handleReplySubmit(question.id, question.emailNotifications)}
                              className="text-sm text-amber-400 hover:text-amber-300 transition disabled:opacity-50"
                            >
                              {replying === question.id ? 'Replying...' : 'Submit Reply'}
                            </button>
                          </div>
                        )}
                      </>
                    ) : (
                      <p className="text-sm text-gray-400 mt-2">You must be signed in to reply.</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </motion.div>

        {/* Submit Question Form */}
        {user ?
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10"
          >
            <h2 className="text-xl font-bold mb-4">Ask a Question</h2>
            <form onSubmit={handleSubmitQuestion}>
              <textarea
                value={newQuestion}
                onChange={(e) => setNewQuestion(e.target.value)}
                placeholder="What would you like to know about this study?"
                className="w-full h-32 bg-white/5 rounded-lg border border-white/10 p-4 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300 resize-none"
                required
              />


              <div className={`flex mt-4 ${studyData?.speaker ? "justify-between items-start" : "justify-end items-center"}`}>
                {/* Dropdown for referredTo */}
                {studyData?.speaker && (
                  <div className="relative">
                    <details className="bg-white/5 border border-white/10 rounded p-2">
                      <summary className="cursor-pointer text-sm text-gray-300">
                        Address to: {referredTo || 'Select speaker(s)'}
                      </summary>
                      <div className="mt-2 space-y-2">
                        {studyData.speaker.split(',').map((name) => {
                          const trimmed = name.trim();
                          return (
                            <label key={trimmed} className="flex items-center gap-2 text-sm text-gray-200">
                              <input
                                type="checkbox"
                                checked={referredTo.split(',').map(s => s.trim()).includes(trimmed)}
                                onChange={() => toggleReferredTo(trimmed)}
                              />
                              {trimmed}
                            </label>
                          );
                        })}
                      </div>
                    </details>
                  </div>
                )}

                <motion.button
                  type="submit"
                  disabled={submitting || !newQuestion.trim()}
                  className="flex items-center gap-2 bg-gradient-to-r from-amber-600 to-blue-600 hover:from-amber-700 hover:to-blue-700 disabled:opacity-50 disabled:cursor-not-allowed px-6 py-3 rounded-lg text-white font-medium transition-all duration-300"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <Send className="w-4 h-4" />
                  <span>{submitting ? 'Submitting...' : 'Ask Question'}</span>
                </motion.button>
              </div>
            </form>
          </motion.div>
          :
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10"
          >
            <h2 className="text-xl font-bold mb-4">Log In, to ask your question.</h2>
            <motion.button
              type="submit"
              // disabled={submitting || !newQuestion.trim()}
              onClick={() => window.location.href = "/login"}
              className="flex items-center gap-2 bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-700 hover:to-blue-700 disabled:opacity-50 disabled:cursor-not-allowed px-6 py-3 rounded-lg text-white font-medium transition-all duration-300"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <UserCogIcon className="w-4 h-4" />
              <span>Log In</span>
            </motion.button>
          </motion.div>
        }
      </div>
    </motion.div>
  );
}




// [
//           {
//             id: '1',
//             content: 'How do we know when we are operating in divine authority versus our own will?',
//             author: 'Sarah M.',
//             timestamp: '2 hours ago',
//             answer: {
//               content: 'Great question! Divine authority always aligns with God\'s word and character. When we operate in divine authority, there\'s peace, it glorifies God, and it produces good fruit. Our own will often comes with anxiety, pride, or results that don\'t align with biblical principles.',
//               author: 'Dr. Flourish Peters',
//               timestamp: '1 hour ago',
//               isOfficial: true
//             },
//             replies: [
//               {
//                 id: 'r1',
//                 content: 'This really helps clarify things. Thank you!',
//                 author: 'John D.',
//                 timestamp: '45 minutes ago'
//               },
//               {
//                 id: 'r2',
//                 content: 'I would add that prayer and seeking counsel from mature believers also helps us discern.',
//                 author: 'Pastor Mike',
//                 timestamp: '30 minutes ago',
//                 isReplyToAnswer: true
//               }
//             ]
//           },
//           {
//             id: '2',
//             content: 'Can you give practical examples of exercising spiritual authority in everyday situations?',
//             author: 'Michael K.',
//             timestamp: '3 hours ago',
//             replies: []
//           },
//           {
//             id: '3',
//             content: 'What scriptures should we memorize to help us walk in authority?',
//             author: 'Grace L.',
//             timestamp: '4 hours ago',
//             answer: {
//               content: 'Some key scriptures include: Luke 10:19, Matthew 28:18-20, Ephesians 6:10-18, James 4:7, and 1 John 4:4. I recommend starting with these and meditating on them daily.',
//               author: 'Dr. Flourish Peters',
//               timestamp: '2 hours ago',
//               isOfficial: true
//             },
//             replies: [
//               {
//                 id: 'r3',
//                 content: 'Thank you for these references!',
//                 author: 'David R.',
//                 timestamp: '1 hour ago',
//                 isReplyToAnswer: true
//               }
//             ]
//           }
//         ]
